<template>
  <div class="footer" v-if="!isGrupoFamiliar">
    <footer>
      <div class="container-logo-faq">
        <img
  src="../assets/logo_conecta_blanco.svg"
  class="logo"
  alt="Logo Conecta"
  width="400"
  height="55"
  decoding="async"
  loading="lazy"
/>
      </div>
      
      <v-divider style="color:white;"/>

      <div class="footer-container">
    <!--     <div class="addresses"> -->

            <div class="address">
              <p>Superintendencia de Servicios de Salud - 
                0800 - 222 - 72583 (SALUD) - www.sssalud.gob.ar - R.N.E.M.P.(Prov.) 1297
              </p>
            </div>

            <div class="address"></div>
            <ul>
          <li> <router-link to="/terminos">Términos y condiciones</router-link> </li>
          <li> <router-link to="/nosotros">Sobre nosotros</router-link>  </li>
          <li> <router-link to="/politicasprivacidad">Políticas de privacidad</router-link>  </li>
        </ul>
  <!--       </div> -->

        
      </div>
    </footer>

    <div class="container-filation">
     <img
  src="../assets/FiliationLogo.svg"
  class="filiation-logo"
  alt="Filiation"
  width="138"
  height="20"
  decoding="async"
  loading="lazy"
/>
    </div>
  </div>

</template>

<script>


export default {
  components:{},
  methods:
  {
    goToNosotros()
    {
      window.open('https://www.urgconecta.com.ar/faq', '_blank');
    }
  },
  computed:
  {
    isGrupoFamiliar()
    {
      return this.$route.name === "grupofamiliar"
    }
  }
}
</script>

<style scoped>
.theme--light.v-divider {
  border-color: white !important; 
}

.btn-faq
{
  color: white !important;
  background-color: var(--secondary-color) !important;
  border: 1px solid var(--secondary-color) !important;
  height: 60px !important;
}

footer
{
  background-color: var(--primary-color);
  margin-top: 95px;
  padding: 10px 20vw;
  padding-top: 25px;
}

footer p
{
  margin:0;
}

.container-logo-faq
{
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.container-logo-faq img
{
  width: 400px;
}

.footer-container
{
  margin-top: 20px;
  display: grid;
  grid-template-columns: 55% 15% 30%;
  width: 100%;
  line-height: 1.6;
  text-align: start;
  color: white;
}

.addresses
{
  color: #FFFFFF;
  font-weight: 400;
}

.addresses strong
{
  color: white;
  font-size: 15px;
  margin:5px 0;
}

.address
{
  margin:10px 20px;
  color: #DDE0EB;
}

footer ul
{
  list-style-type: none;
  align-self: center;
  padding: 0;
  margin: 0;
  text-align: end;
}

footer ul li
{
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 8px;
}

footer ul li a
{
  color: white;
  text-decoration: none;
}

footer ul li::before
{
  content:  \f105;
  margin-right: 5px;
}

.container-filation
{
  padding: 10px 20vw;
  font-size: 12px;
  color: white;
  background-color: #16191e;
  font-size: 12px;
  display: flex;
  justify-content: center;
}

.container-filation p
{
  margin: 0;
  font-size: 12px;
}

.container-filation img
{
  width: 138px;
}

.container-filation a
{
  color: white;
  text-decoration: none;
}


.buttons
{
  margin-top: 15px;
  display: flex;
  gap:15px;
  align-items: center;
  justify-content: center;
}

.router
{
  display: flex;
  align-items: center;
  justify-content: center;

  height: 48px;
  width: 250px;
  border-radius: 3px;

  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  margin:0;

  text-decoration: none;
}

.office .v-icon {
  margin-right:8px;
}


.filiation {
  height: 32px;  
  margin-top: 115px;
  background-image: -webkit-linear-gradient(-30deg, var(--primary-color) 0% 3%, #AFD54D 3% 9% , #1197BD 9% 15%, var(--primary-color) 12%);
}

.filiation img {
  display: block;
  position: relative;
  margin: 0 auto 0 auto;
  top: 6px;
}

@media (max-width: 860px) 
{
  .container-logo-faq
  {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .container-logo-faq img
  {
    width: 250px;
  }

  .btn-faq
  {
    margin:10px 0;
    width: 100%;
  }
  
  .addresses
  {
    text-align: center;
  }

  

  .buttons
  {
    flex-direction: column;
  }

  .office h1 {
    margin-top: 50px;
  }

  .office .btn {
    display: block;
    margin: 20px auto auto auto;
  }

  .filiation
  {
    margin-top: 50px;
  }

  footer {
    margin-top: 67px;
  }
  .footer-container
  {
    display: block;
  }

  .container-filation
  {
    display: block;
  }

  footer ul 
  {
    text-align: center;
  }
}

</style>